import React, { useState } from 'react';

import { LoadingButton } from '@mui/lab';
import {
  Button,
  Stack,
  FormControl,
  InputAdornment,
  OutlinedInput,
  Card,
  CardContent,
  CardHeader,
  InputLabel,
} from '@mui/material';
import { useFinanceContext } from 'src/components/plaid/datasource/index';
import { NumericFormatCustom } from 'src/sections/scenarios/NumericFormatCustom';
import GoalCategorySelector from './goal-category-select';

// import { DateField } from '@mui/x-date-pickers';

export default function AddGoalRowForm({ expand, setExpand }) {
  const {
    goalService: { addGoal },
  } = useFinanceContext();

  const [amount, setAmount] = useState(null);
  // const [targetDate, setTargetDate] = useState(new Date());
  const [category, setCategory] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleAdd = () => {
    setLoading(true);
    addGoal(category?.id, amount).then(() => {
      setLoading(false);
      setExpand(false);
    });
  };

  const isValid = amount && category?.id;

  return (
    <Card sx={{ overflow: 'visible' }}>
      <CardHeader title="Create a Goal" />
      <CardContent>
        <Stack spacing={1} sx={{ width: '100%' }}>
          {expand && (
            <>
              <Stack direction="row" spacing={1}>
                <GoalCategorySelector value={category} onChange={setCategory} />
                <FormControl fullWidth size="small">
                  <InputLabel id="amount-label">Amount</InputLabel>

                  <OutlinedInput
                    id="amount"
                    labelId="amount-label"
                    label="Amount"
                    value={amount}
                    onChange={(e) => setAmount(Number(e.target.value))}
                    inputComponent={NumericFormatCustom}
                    startAdornment={<InputAdornment position="start">$</InputAdornment>}
                    endAdornment={<InputAdornment position="end">/ mo</InputAdornment>}
                    inputProps={{
                      'aria-label': `Amount`,
                    }}
                  />
                </FormControl>
              </Stack>
              {/* <FormControl fullWidth size="small">
                <DateField
                  label="Reach By Date"
                  value={targetDate}
                  onChange={setTargetDate}
                  size="small"
                />
              </FormControl> */}
            </>
          )}

          {!expand && (
            <Button variant="outlined" color="primary" fullWidth onClick={() => setExpand(true)}>
              Add Goal
            </Button>
          )}
          {expand && (
            <Stack direction="row" spacing={1}>
              <Button onClick={() => setExpand(false)}>Cancel</Button>

              <LoadingButton
                variant="outlined"
                color="primary"
                fullWidth
                onClick={handleAdd}
                disabled={!isValid}
                loading={loading}
              >
                Create Goal
              </LoadingButton>
            </Stack>
          )}
        </Stack>
      </CardContent>
    </Card>
  );
}
